module.exports = __webpack_public_path__ + "b9ea389a8d1683f5a36221205133bf23.png";